import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import ProductGallery from "../../../../frontend-productgallery/ProductGallery.vue";
import { ProductGalleryItem } from "../../list-item";


export default /*@__PURE__*/_defineComponent({
  __name: 'product-gallery',
  props: {
    item: {
        type: ProductGalleryItem,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const products = ref(props.item.segment.products);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(ProductGallery, {
      tag: "li",
      class: "product-gallery-item-wrapper full-span-item",
      header1: __props.item.segment.title ?? undefined,
      products: products.value
    }, null, 8 /* PROPS */, ["header1", "products"]), [
      [_vShow, products.value.length > 0]
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("li", { class: "gallery-separator" }, [
      _createElementVNode("hr")
    ], -1 /* HOISTED */))
  ], 64 /* STABLE_FRAGMENT */))
}
}

})